/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationSaveMonographRequestViewModel } from "../types/CourseRegistrationSaveMonographRequestViewModel.ts";
import { eMonographPresentationFinalStatusSchema } from "./eMonographPresentationFinalStatusSchema.ts";

export const courseRegistrationSaveMonographRequestViewModelSchema = z.object({
  presentationId: z
    .number()
    .int()
    .describe("ID da apresentação da monografia a ser atualizada. Opcional.")
    .nullish(),
  presentationGrade: z
    .number()
    .describe("Nota da apresentação da monografia. Opcional.")
    .nullish(),
  examGrade: z
    .number()
    .describe("Nota da avaliação escrita da monografia. Opcional.")
    .nullish(),
  finalGrade: z
    .number()
    .describe("Nota final calculada da monografia. Opcional.")
    .nullish(),
  finalStatus: z.optional(
    z
      .lazy(() => eMonographPresentationFinalStatusSchema)
      .describe("1 = Approved | 2 = Failed | 3 = TemporarilyReproved | "),
  ),
  toLibrary: z.optional(
    z
      .boolean()
      .describe("Indica se a monografia deve ser enviada para a biblioteca."),
  ),
  toRevision: z.optional(
    z
      .boolean()
      .describe("Indica se a monografia deve ser encaminhada para revisão."),
  ),
}) as unknown as ToZod<CourseRegistrationSaveMonographRequestViewModel>;
